<template>
    <ClientSummary
        v-if="!isError.hasError && !isLoading"
        :client="infoClient"
        :ui="ui"
        :balance="infoClient.total"
        :status-class="typeClassConvenio"
        @back="$emit('back')"
    />
    <div class="container_submenu" v-if="!isError.hasError && !isLoading">
        <header>
            <v-card-title>Histórico de Pagos</v-card-title>
            <v-divider class="mx-3"></v-divider>
        </header>

        <div class="content_histoty_pay" v-if="!isLoading">
            <div class="content_history">
                <div class="item_izq_title">Saldo del Plan</div>
                <div class="item_izq_value">{{ infoTotales.saldo_plan  }}</div>
            </div>
            <div class="content_history">
                <div class="item_cen_title">Avance del Plan</div>
                <div class="item_cent_value">{{ infoTotales.avance_plan }}</div>
            </div>
            <div class="content_history">
                <div class="item_der_title">Por Pagar</div>
                <div class="item_der_value">{{ infoTotales.por_pagar }}</div>
            </div>
            <div class="content_history">
                <div class="item_last_title_v2">Tipo plan</div>
                <div class="item_last_value">{{ infoTotales.tipo_plan }}</div>
            </div>
        </div>

        <div class="content_load" v-if="isLoading">
            <v-progress-circular
                :size="100"
                :width="7"
                color="indigo-darken-3"
                indeterminate
            ></v-progress-circular>
            <i>Espere un momento</i>
            <div>Cargando información de los pagos</div>
        </div>

        <div class="content_accion">
            <div>
                <v-text-field
                    v-model="searchHistory"
                    label="Búsqueda"
                    prepend-inner-icon="mdi-magnify"
                    single-line
                    variant="outlined"
                    hide-details
                    :disabled="isLoading"
                    class="filter"
                ></v-text-field>
            </div>
            <div>
                <v-btn
                    icon="mdi-reload"
                    size="small"
                    variant="outlined"
                    color="indigo-darken-3"
                    class="mr-2"
                    :disabled="isLoading"
                    @click="paymentHistoric()"
                ></v-btn>
            </div>
        </div>
        <v-data-table
            :headers="dataSource.headers"
            :items="dataSource.data"
            :search="searchHistory"
            :loading="isLoading"
            no-data-text="Sin datos para mostrar"
            loading-text="Cargando información... Espere un momento"
        >
            <template v-slot:item="{ item }">
                <tr>
                    <td>{{ item.numero_pagos }}</td>
                    <td>{{ item.fecha_prometida }}</td>
                    <td>{{ item.monto_prometido }}</td>
                    <td>{{ item.fecha_pago_real }}</td>
                    <td>{{ item.pago_real }}</td>
                    <td>{{ item.acumulado_real }}</td>
                    <td>{{ item.acumulado_esperado }}</td>
                    <td :style="{backgroundColor: item.pagado <= 0 ? 'rgb(193 236 169)' : 'rgb(255 134 26)'}">{{ item.pagado }}</td>
                </tr>
            </template>
        </v-data-table>
    </div>

    <div v-if="isError.hasError && !isLoading" class="has_error">
        <div>
            <img src="@/assets/images/hasError.svg">
        </div>
        <div>{{ isError.msg }}</div>
    </div>
    <div v-if="isLoading" class="content_load h-100" >
        <v-progress-circular
            :size="100"
            :width="7"
            color="indigo-darken-3"
            indeterminate
        ></v-progress-circular>
        <i>Espere un Momento</i>
        <div>Cargando la Información del Historico de Pagos</div>
    </div>

    <SnackbarComponent :value="snackbarData"/>
</template>
<script>
import ClientSummary from '@/components/managements/ClientSummary.vue'
import { EncryptService } from '@/services/EncryptService';
import { ManagementsService } from '@/services/ManagementsService';
import { ResourcesService } from '@/services/ResourcesService';
import SnackbarComponent from '@/components/Snackbar'
import { useUiStore } from '@/stores/ui'
export default {
    name: "PaymentHistoryView",
    emits: ['back'],
    props: {
        msg: String,
    },
    components: {
        ClientSummary,
        SnackbarComponent,
    },    
    data() {
        return {
            idClient: null,
            isLoading: false,
            searchHistory: '',
            isError: {
                hasError: false,
                msg: '',
            },
            snackbarData: {
                openSnackbar: false,
                description: '',
            },
            dataSource: {
                data: [],
                headers: [
                {
                    align: "start",
                    key: "numero_pagos",
                    title: "Número de Pagos",
                },
                {
                    key: "fecha_prometida",
                    title: "Fecha Prometida",
                },
                {
                    key: "monto_prometido",
                    title: "Monto Prometido",
                },
                {
                    key: "fecha_pago_real",
                    title: "Fecha Pago Real",
                },
                {
                    key: "pago_real",
                    title: "Pago Real",
                },
                {
                    key: "acumulado_real",
                    title: "Acumulado Real",
                },
                {
                    key: "acumulado_esperado",
                    title: "Acumulado Esperado",
                },
                {
                    key: "pagado",
                    title: "Diferencia",
                },
                ],
            },
            infoTotales: {
                saldo_plan: '...',
                por_pagar: '...',
                avance_plan: '...',
                tipo_plan: '...',
            },
            infoClient: {
                id_cliente: "...",
                nombre: "...",
                saldo: "...",
                estado: "...",
            },
            typeClassConvenio: 'gray',
        }
    },
    computed:{
        ui() {
            const store = useUiStore()
            return store.ui;
        },
    },
    async mounted() {
        const store = useUiStore()
        if (Object.keys(store.ui).length === 0) {
            await store.cargarVocabulario()
        }
    },
    async created() {
        const DATA_PARAMS = this.$route.params.form
        if (DATA_PARAMS === null || DATA_PARAMS === undefined || DATA_PARAMS === '') {
            this.isError.hasError = true
            this.isError.msg = `No existen datos en la URL para obtener la información del cliente. Favor de volver a ingresar al cliente`
            return;
        }
        const PARAMS = await EncryptService.decrypt(DATA_PARAMS)
        if (PARAMS === null || PARAMS === '') {
            this.isError.hasError = true
            this.isError.msg = `Los datos de la URL no fueron encriptados correctamente. Favor de volver a ingresar al cliente.`
            return;
        }
        const ARR_PARAMS = JSON.parse(PARAMS);
        this.idClient = ARR_PARAMS.id

        this.isLoading = true
        await this.getClientInformation()
        await this.paymentHistoric()
        this.isLoading = false
    },
    methods: {
        getClientInformation: async function () {
            const ENC_CLIENT = await EncryptService.encrypt(this.idClient)
            await ManagementsService.getClientInformation(ENC_CLIENT).then(
                (responseData) => {
                    if (!responseData.error) {
                        this.infoClient = responseData.response
                        this.infoClient.total = ResourcesService.moneyFormat(this.infoClient.total)
                        switch (this.infoClient.estado) {
                            case 'Convenio Activo':
                            case 'Convenio Completado':
                            case 'Pago Intención Activo':
                            case 'Pago Intención Completado':
                                this.typeClassConvenio = 'green';
                                break;
                            case 'Sin convenio':
                                this.typeClassConvenio = 'gray';
                                break;
                            case 'Convenio Cancelado':
                            case 'Pago Intención Cancelado':
                                this.typeClassConvenio = 'red';
                                break;
                            default:
                                this.typeClassConvenio = 'gray';
                        }
                    } else {
                        this.snackbarData.description = responseData.msg
                        this.snackbarData.openSnackbar = true
                    }
                }
            )
        },
        paymentHistoric: async function () {
            this.isLoading = true
            const ENC_CLIENT = await EncryptService.encrypt(this.idClient)
            await ManagementsService.paymentHistoric(ENC_CLIENT).then(
                (responseData) => {
                    if (!responseData.error) {
                        this.infoTotales = responseData.response.totales
                        this.infoTotales.saldo_plan = ResourcesService.moneyFormat(this.infoTotales.saldo_plan)
                        this.infoTotales.por_pagar = ResourcesService.moneyFormat(this.infoTotales.por_pagar)
                        this.infoTotales.avance_plan = ResourcesService.moneyFormat(this.infoTotales.avance_plan)
                        this.infoTotales.tipo_plan = responseData.response.totales.tipo_plan;

                        for (const data of  responseData.response.pagos) {
                            data.monto_prometido = ResourcesService.moneyFormat(data.monto_prometido);
                            data.acumulado_esperado = ResourcesService.moneyFormat(data.acumulado_esperado);
                            data.pagado =  ResourcesService.moneyFormat(data.pagado);
                        }
                        this.dataSource.data = responseData.response.pagos
                    } else {
                        this.snackbarData.description = responseData.msg
                        this.snackbarData.openSnackbar = true
                    }
                }
            )
            this.isLoading = false
        },
    }
}
</script>
<style scoped>
    .title_container {
        width: 100%;
        display: flex; 
        justify-content: space-between;
        align-items: center;
        min-height: 50px;
        border-bottom: 1px solid #E3E3E3;
    }
    .title_section {
        width: 25%; 
        display: flex;  
        justify-content: center;
        font-size: 10pt;
    }
    .title_item {
        font-weight: 600;
        margin-right: 4px;
    }
    .container_submenu {
        height: calc(100% - 50px);
        overflow: auto;
        margin-bottom: 30px;
    }
    .content_histoty_pay {
        width: 100%;
        display: flex;
        padding: 20px;
    }
    .isColor {
        background-color: #52c17e;
        font-weight: 600;
    }
    .notColor {
        color: #000000;
    }
    .content_history {
        width: calc(100% / 3);
    }
    .item_izq_title {
        background-color: #3850ce;
        color: #ffffff;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-top-left-radius: 10px;
    }
    .item_izq_value {
        background-color: #778af1;
        color: #ffffff;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-bottom-left-radius: 10px;
    }
    .item_cen_title {
        background-color: #39a328;
        color: #ffffff;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .item_cent_value {
        background-color: #7acd6d;
        color: #ffffff;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
    .item_der_title {
        background-color: #d40f0f;
        color: #ffffff;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
        .item_last_title_v2 {
        background-color: #3e9287e5;
        color: #ffffff;
        height: 50px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-top-right-radius: 10px;
    }
    .item_der_value {
        background-color: #df5f5f;
        color: #ffffff;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
    }
        .item_last_value {
        background-color: #a6dad3e5;
        color: #ffffff;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-bottom-right-radius: 10px;
    }
</style>